export const ACTIVE_LOCK_STATUSES = ['locked', 'completed', 'in_progress'];

export const isActiveLockStatus = (status) => ACTIVE_LOCK_STATUSES.includes(status);

export const countUserLocksForWeek = (locksForWeek, userId) => (
  (locksForWeek || []).filter(
    (lock) => lock.userId === userId && isActiveLockStatus(lock.status)
  ).length
);

/** Lockers visible when setting is on OR viewer has locked / maxed out this week. */
export const canViewerSeeLockers = (showLockers, userLocksCount, maxPicksForWeek) => (
  Boolean(showLockers) || userLocksCount > 0 || userLocksCount >= maxPicksForWeek
);

/** Lock details visible when setting is on OR viewer has maxed picks this week. */
export const canViewerSeeLocks = (showLocks, userLocksCount, maxPicksForWeek) => (
  Boolean(showLocks) || userLocksCount >= maxPicksForWeek
);

export const shouldShowLockUsername = ({
  isUserLock,
  showLockers,
  userLocksCount,
  maxPicksForWeek,
}) => (
  isUserLock || canViewerSeeLockers(showLockers, userLocksCount, maxPicksForWeek)
);

export const shouldShowLockPickInfo = ({
  showLocks,
  userLocksCount,
  maxPicksForWeek,
}) => (
  canViewerSeeLocks(showLocks, userLocksCount, maxPicksForWeek)
);

export const shouldShowGameLocksSection = ({
  showLocks,
  userLocksCount,
  maxPicksForWeek,
  hasLocks,
}) => (
  Boolean(hasLocks) && canViewerSeeLocks(showLocks, userLocksCount, maxPicksForWeek)
);
